import * as styles from "./DatePickerDay.css";

import type { JSX } from "react";

import { useDatePickerContext } from "./DatePicker.context";
import type { DatePickerDayProps } from "./DatePicker.types";

export function DatePickerDay({
  year,
  month,
  day,
  outsideMonth,
  selected,
  today,
  active,
  disabled,
  inRange = false,
  rangeStart = false,
  rangeEnd = false,
}: DatePickerDayProps): JSX.Element {
  const { selectDay, range, setHoveredDay } = useDatePickerContext();

  return (
    <button
      type="button"
      role="gridcell"
      data-slot="date-picker-day"
      data-year={year}
      data-month={month}
      data-day={day}
      data-outside-month={outsideMonth ? "" : undefined}
      data-today={today ? "" : undefined}
      data-selected={selected ? "" : undefined}
      data-in-range={inRange ? "" : undefined}
      data-range-start={rangeStart ? "" : undefined}
      data-range-end={rangeEnd ? "" : undefined}
      aria-selected={selected}
      aria-disabled={disabled}
      tabIndex={active ? 0 : -1}
      disabled={disabled}
      className={styles.day}
      onClick={() => selectDay(year, month, day)}
      onPointerEnter={
        range ? () => setHoveredDay({ year, month, day }) : undefined
      }
      onFocus={range ? () => setHoveredDay({ year, month, day }) : undefined}
    >
      {day}
    </button>
  );
}
